import styled, { keyframes, css } from 'styled-components'

const entrar = keyframes`
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
`
const pular = keyframes`
  0%, 80%, 100% { transform: scale(0.6); opacity: .4; }
  40% { transform: scale(1); opacity: 1; }
`
const brilho = keyframes`
  0% { background-position: 0% 50%; }
  100% { background-position: 200% 50%; }
`

// respeita quem prefere menos movimento
const animacao = (a, dur = '.35s', atraso = 0) => css`
  animation: ${a} ${dur} ease-out both;
  animation-delay: ${atraso}s;
  @media (prefers-reduced-motion: reduce) { animation: none; }
`

export const Cabecalho = styled.div`
  background: linear-gradient(120deg, #13143a 0%, #1e3a8a 55%, #2563eb 100%);
  color: #fff;
  padding: 16px 18px;
  display: flex;
  align-items: center;
  gap: 12px;
`
export const Avatar = styled.div`
  width: 40px; height: 40px; border-radius: 12px; flex: none;
  display: grid; place-items: center; font-size: 20px;
  background: linear-gradient(135deg, #60a5fa, #a78bfa, #60a5fa);
  background-size: 200% 200%;
  ${css`animation: ${brilho} 6s linear infinite;`}
  @media (prefers-reduced-motion: reduce) { animation: none; }
`
export const Corpo = styled.div`
  flex: 1; overflow-y: auto; padding: 16px; background: var(--yrm-surface-2);
  display: flex; flex-direction: column; gap: 12px;
`
export const Balao = styled.div`
  max-width: 88%;
  padding: 10px 14px;
  border-radius: 16px;
  font-size: 14px;
  ${(p) => (p.$meu ? css`
    align-self: flex-end; background: #2563eb; color: #fff; border-bottom-right-radius: 4px;
  ` : css`
    align-self: flex-start; background: var(--yrm-surface); color: var(--yrm-text); border: 1px solid var(--yrm-border); border-bottom-left-radius: 4px;
    box-shadow: 0 1px 2px rgba(15, 23, 42, .04);
  `)}
  ${animacao(entrar)}
`
export const Digitando = styled.div`
  align-self: flex-start; display: flex; gap: 4px; padding: 12px 14px;
  background: var(--yrm-surface); border: 1px solid var(--yrm-border); border-radius: 16px;
  span { width: 7px; height: 7px; border-radius: 50%; background: #2563eb; }
  span:nth-child(1) { ${css`animation: ${pular} 1.2s infinite ease-in-out;`} }
  span:nth-child(2) { ${css`animation: ${pular} 1.2s .15s infinite ease-in-out;`} }
  span:nth-child(3) { ${css`animation: ${pular} 1.2s .3s infinite ease-in-out;`} }
  @media (prefers-reduced-motion: reduce) { span { animation: none !important; } }
`
export const Chip = styled.button`
  border: 1px solid #c7d2fe; background: var(--yrm-tint-azul); color: #1e3a8a; border-radius: 999px;
  padding: 6px 12px; font-size: 13px; cursor: pointer; text-align: left;
  transition: background .15s, transform .15s;
  &:hover { background: var(--yrm-tint-azul); transform: translateY(-1px); }
  &:focus-visible { outline: 2px solid #2563eb; outline-offset: 2px; }
  ${(p) => animacao(entrar, '.3s', p.$i * 0.05)}
`
export const Cartao = styled.section`
  background: var(--yrm-surface); border: 1px solid var(--yrm-border); border-radius: 14px; padding: 14px;
  ${animacao(entrar, '.4s')}
`
export const ItemAnimado = styled.div`
  ${(p) => animacao(entrar, '.35s', 0.08 + (p.$i || 0) * 0.06)}
`
export const Rodape = styled.div`
  border-top: 1px solid var(--yrm-border); padding: 10px 12px; background: var(--yrm-surface);
`
